import React from 'react';
import './styles/styles.scss'
import ChartLayout from './components/ChartLayout'
import ChartContextProvider from './context/ChartContext'
import { Helmet } from 'react-helmet'


const JusticeAndPeaceDashboard = () => {

    return ( 
        <div className="justice-and-peace-dashboard">
          <Helmet>
            <title>Hear Their Voices - Boring Bar Chart</title>
          </Helmet>
          <ChartContextProvider>
            <ChartLayout/>
          </ChartContextProvider>
        </div>
     );
}
 
export default JusticeAndPeaceDashboard;